import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9qv2bhnwv6: FaireBrandEntity = {
  token: "b_9qv2bhnwv6",
  type: "brand",
  name: "Bazou",
  avatarUrl:
    "https://cdn.faire.com/fastly/6b4926f718d929cb96671a18902046d23b7407a6fba1ee92f6a8ddbe7c58e732.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4186051878b558b86cfc459e7a3693ace1711305ba42e420a4a14de016db033a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6b4926f718d929cb96671a18902046d23b7407a6fba1ee92f6a8ddbe7c58e732.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4186051878b558b86cfc459e7a3693ace1711305ba42e420a4a14de016db033a.png",
  location: "Rotterdam, NLD",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 303,
  isTopShop: true,
  isInsider: false,
  description:
    "We are Babeth & Anouk, founders of Bazou. Bazou is a Dutch label based in Rotterdam and we create fancy, affordable, high quality jewellry pieces. Currently, our collection consists of silver steel and gold-plated rings, fine and statement earrings, necklaces and handmade bracelets. \nWe design our jewelry for the fashion-conscious woman who likes to stand out, but not too much. Wear a statement piece or subtle, elegant items. Our goal is to find the balance between the extravagant and the subtle with every collection released. All the jewellry can be mixed and matched into your perfect jewelry stack, ear and arm-party ultimately creating your own individual style. \n\nFor our wholesale clients we offer:  \n-\tMargin: 2,4 \n-\tNo minimum order \n-\tPackaging bags with brand cards\n-\t4 new collections per year\n-\tHigh quality Jewellry (no discoloration)\n-\tAffordable prices\n-\tPhoto material \n\nFeel free to contact us if you have any questions! Also you can check out our Instagram to have a closer look and find out our style - www.instagram.com/by_bazou/",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:09.193Z",
    importedBy: "entity-db-cli",
  },
};
